import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportStatCard = ({ title, value, subtitle, icon, color = 'accent', trend, trendLabel }) => {
  const colorMap = {
    accent: 'bg-accent/10 text-accent',
    green: 'bg-green-500/10 text-green-500',
    blue: 'bg-blue-500/10 text-blue-500',
    yellow: 'bg-yellow-500/10 text-yellow-500',
    red: 'bg-red-500/10 text-red-500',
    purple: 'bg-purple-500/10 text-purple-500'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-5">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${colorMap?.[color] || colorMap?.accent}`}>
          <Icon name={icon} size={20} />
        </div>
        {trend !== undefined && (
          <span className={`text-xs font-medium flex items-center gap-1 ${
            trend >= 0 ? 'text-green-600' : 'text-red-600'
          }`}>
            <Icon name={trend >= 0 ? 'TrendingUp' : 'TrendingDown'} size={14} />
            {Math.abs(trend)}%
          </span>
        )}
      </div>
      <p className="text-2xl font-bold text-foreground mb-1">{value}</p>
      <p className="text-sm font-medium text-foreground">{title}</p>
      {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
      {trendLabel && <p className="text-xs text-muted-foreground mt-1">{trendLabel}</p>}
    </div>
  );
};

export default ReportStatCard;
